import { gettext } from '@eventbrite/i18n';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import take from 'lodash/take';
import React from 'react';
import { useMount } from 'react-use';
import { CardBucket } from '../../../../../../components/CardBucket';
import { LIST_CARD_TEMPLATE } from '../../../../../../constants';
import { SEARCH_SECTION } from '../../../../../../constants/analytics';
import {
    bboxShape,
    FeatureFlags,
    ShareOptions,
} from '../../../../../../types/index';

interface EventSuggestionsProps {
    eventSuggestions: object[];
    shareOptions: ShareOptions;
    isAuthenticated?: boolean;
    allEventsUrl?: string;
    featureFlags: FeatureFlags;
    trackGAEventOnPageUnload?: Function;
    suggestionsLoading: boolean;
    trackGAEvent?: Function;
    searchEventSuggestionsAction: Function;
    hasEventResults: boolean;
    bbox: bboxShape;
}

export const EventSuggestions = (props: EventSuggestionsProps) => {
    const {
        eventSuggestions,
        shareOptions,
        isAuthenticated,
        allEventsUrl,
        featureFlags,
        trackGAEventOnPageUnload,
        suggestionsLoading,
        trackGAEvent,
        searchEventSuggestionsAction,
        hasEventResults,
        bbox,
    } = props;

    useMount(() => {
        if (!hasEventResults && !isEmpty(bbox)) {
            searchEventSuggestionsAction(true);
        } else if (isEmpty(eventSuggestions)) {
            searchEventSuggestionsAction();
        }
    });

    if (isEmpty(eventSuggestions) && !suggestionsLoading) {
        return null;
    }

    const trackSeeMore = (_: any, linkUrl: string) => {
        props.trackGAEvent?.({
            action: 'ViewMore',
            label: linkUrl,
        });
    };

    let content = map(eventSuggestions, (event = {}) => ({
        ...event,
        section: SEARCH_SECTION,
        excludeExtraContent: true,
    }));

    content = take(content, 5);

    return (
        <div className="pivot-section eds-l-pad-bot-4">
            <CardBucket
                trackSeeMore={trackSeeMore}
                isLoading={suggestionsLoading}
                content={content}
                template={LIST_CARD_TEMPLATE}
                shareOptions={shareOptions}
                name={gettext('Popular events')}
                linkUrl={allEventsUrl}
                isAuthenticated={isAuthenticated}
                featureFlags={featureFlags}
                bucketKey="near_you"
                trackGAEventOnPageUnload={trackGAEventOnPageUnload}
                trackGAEvent={trackGAEvent}
            />
        </div>
    );
};
